<template>
  <nuttrema-layout-content-header>
    <user-info-small-card
       slot="left"
      :personDetails="PersonDetails.data">
    </user-info-small-card>
    <nuttrema-group-and-sort
      slot="center"
      class="is-centered">
      <h4 v-if="_has(meta, 'section')" slot="label" class="no-padding is-uppercase is-gray">
        {{ $t(meta.section) }}
      </h4>
      <h4 v-if="_has(meta, 'title')" slot="content" class="content--title">
        {{ $t(meta.title) }}
      </h4>
    </nuttrema-group-and-sort>
    <template slot="right">
      <slot name="edit"></slot>
      <div class="content-header-item">
         <el-button type="primary" :plain="true" size="mini" class="is-icon" @click="handleShowPage(EVENT.SHOW_PAGE_HELP)">
          <i class="far fa-question"></i>
          <span>{{ $t('label.help') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-content-header>
</template>

<script>
import Emitter from 'components/mixins/emitter';
import * as EVENT from 'constants/event';

import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

import UserInfoSmallCard from 'components/ui/card/user-info-small-card';

export default {
  name: 'cmpt-stuff-to-eat-standard-header',
  mixins: [
    Emitter,
  ],
  props: {
    meta: {
      required: false,
    },
    PersonDetails: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      EVENT,
    };
  },
  components: {
    UserInfoSmallCard,
    NuttremaGroupAndSort,
    NuttremaLayoutContentHeader,
  },
  methods: {
    handleShowPage(event) {
      this.dispatch('PagePersonDetailsView', event);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header.vue